import React from 'react';
import { useDragLayer } from 'react-dnd';
import { ColumnDragLayer, ColumnResizer } from '../styles';

const DynamicTableDragLayer = (props) => {
  const { scaling, tableRef, tableUUID } = props;

  const {item, itemType, isDragging, initialClientOffset, clientOffset} = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    initialClientOffset: monitor.getInitialSourceClientOffset(),
    clientOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || (itemType !== 'column' && itemType !== 'col-resize' && itemType !== 'row-resize')) {
    return null;
  }

  if (item.itemUUID !== tableUUID) {
    return null;
  }

  if (itemType === 'col-resize') {
    return (
      <ColumnDragLayer style={{
        width: 4,
        left: Math.min((clientOffset?.x - tableRef.current?.getBoundingClientRect()?.left) / scaling, tableRef.current?.getBoundingClientRect()?.right / scaling),
        top: 0,
        backgroundColor: 'black'
      }} />
    );
  } else if (itemType === 'row-resize') {
    return (
      <ColumnDragLayer style={{
        width: '100%',
        top: Math.min((clientOffset?.y - tableRef.current?.getBoundingClientRect()?.top) / scaling, tableRef.current?.getBoundingClientRect()?.bottom / scaling),
        left: 0,
        backgroundColor: 'black',
        height: 4
      }} />
    );
  }

  const columnDOMRect = document.getElementById(`tr-${item.uuid}`)?.getBoundingClientRect();
  const headerLeft = columnDOMRect.left;
  const distance = initialClientOffset?.x - headerLeft;

  const initialColumnX = clientOffset?.x - distance;
  const xOffset = (initialColumnX - tableRef.current?.getBoundingClientRect()?.left) / scaling;

  return (
    <ColumnDragLayer style={{
      width: columnDOMRect.width / scaling,
      left: xOffset
    }}/>
  );
}

export default DynamicTableDragLayer;